// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__wEGxO","spin":"Spinner_spin__s6k21"};